import React from 'react';
import AccountAvatarTrigger from '../avatars/AccountAvatarTrigger';

export default function ChatSidePanelProfileBlock({
  wrapperClassName = 'side-panel-profile',
  avatarClassName = 'side-avatar',
  avatarClickableClassName = 'chat-avatar--clickable',
  avatarUrl = '',
  avatarStyle = undefined,
  avatarAlt = '',
  avatarFallback = '',
  onAvatarClick,
  stopAvatarPropagation = true,
  bodyClassName = 'side-profile-body',
  nameClassName = 'side-name',
  metaClassName = 'side-meta',
  name = '',
  badges = [],
  metas = [],
}) {
  const safeBadges = Array.isArray(badges) ? badges.filter(Boolean) : [];
  const safeMetas = Array.isArray(metas) ? metas.filter(Boolean) : [];

  return (
    <div className={wrapperClassName}>
      <AccountAvatarTrigger
        className={avatarClassName}
        clickableClassName={avatarClickableClassName}
        imageUrl={avatarUrl || ''}
        imageAlt={avatarAlt || name || 'プロフィール'}
        style={avatarStyle}
        fallback={!avatarUrl ? avatarFallback || '' : null}
        onClick={onAvatarClick}
        stopPropagation={stopAvatarPropagation}
      />
      <div className={bodyClassName}>
        {name ? <div className={nameClassName}>{name}</div> : null}
        {safeBadges.map((badge, index) => (
          <div key={`side-panel-badge-${index}`} className="side-badge">{badge}</div>
        ))}
        {safeMetas.map((meta, index) => (
          <div key={`side-panel-meta-${index}`} className={metaClassName}>{meta}</div>
        ))}
      </div>
    </div>
  );
}
